<script>
import { gqlClient } from "@root/apollo/apollo-options";
import { queryDataDictionaryListLang } from "@root/graphql/Root.gql";

export const ddValueReDeal = list => {
  let result = [];

  list.forEach(item => {
    if (/.*,.*/.test(item.value)) {
      const { label, value } = item;

      value.split(",").forEach(v => {
        result.push({
          ...item,
          label,
          value: v
        });
      });

      return;
    }

    result.push(item);
  });

  return result;
};

export const expandArrayToMap = list => {
  const result = {};

  list.forEach(item => (result[item.value] = item));

  return result;
};

export default {
  name: "DPicker",
  data() {
    return {
      options: []
    };
  },
  props: {
    code: {
      type: String,
      required: true
    },
    lang: {
      type: String,
      default: ""
    },
    stateName: {
      type: String,
      default: ""
    },
    "filter-method": {
      type: Function
    },
    "auto-select": {
      type: Boolean,
      default: false
    },
    dataFactory: {
      // 可以对下拉列表数据加工,必须有return
      type: Function
    }
  },
  render(h) {
    return h("gt-smart-select", {
      props: {
        options:
          this.filterMethod && this.filterMethod instanceof Function
            ? this.options.filter(this.filterMethod)
            : this.options,
        clearable: true,
        filterable: true,
        placeholder: this.$t("Root.Basic.Select"),
        ...this.$attrs
      },
      on: {
        ...this.$listeners
      }
    });
  },
  async beforeMount() {
    await this.init();
  },
  methods: {
    async init(query = "") {
      let dataList = [];

      try {
        const {
          data: { api: list }
        } = await gqlClient.query({
          query: queryDataDictionaryListLang,
          variables: {
            input: {
              ddCode: this.code,
              lang: this.lang
            }
          }
        });

        dataList = list;
      } catch (err) {
        console.error(err);
      }
      if (this.dataFactory && typeof this.dataFactory === "function") {
        dataList = this.dataFactory(dataList);
      }

      this.options = ddValueReDeal(dataList);

      if (this.options.length && this.autoSelect) {
        this.value = this.options[0].value;
        this.$emit("input", this.value);
      }

      if (this.stateName) {
        this.addToStore(this.stateName);
      }
    },

    // 将获取到的list，dispatch到store
    addToStore(stateName) {
      // store.registerModule(
      //   ["root", "ddcode"],
      //   {
      //     state: {
      //       [stateName]: this.options
      //     }
      //   },
      //   { preserveState: true }
      // );

      // this.$store.commit("root/ddcode/easyMutate", {
      //   path: `data.${stateName}`,
      //   data: this.options
      // });

      this.$store.commit("root/UPDATE_DDCODE", {
        name: stateName,
        value: [...this.options]
      });
    },

    // 下面是暴露给外部作用域的方法
    getBindEnum() {
      return this.options;
    },

    getBindMap() {
      return expandArrayToMap(this.options);
    },

    getBindLabel() {
      let data = this.getBindData();

      return data ? data.label : "";
    },

    getBindData() {
      return this.options.find(item => item.value === this.$attrs.value);
    }
  }
};
</script>
